import {RegisterFormProps} from './Register.schema';

export type StepKey = 'voce' | 'perfil' | 'verificacao';

export interface StepDefinition {
  key: StepKey;
  label: string;
  title: string;
}

export const STEPS: readonly StepDefinition[] = [
  {key: 'voce', label: 'Você', title: 'Comece agora a transformar sua carreira'},
  {key: 'perfil', label: 'Perfil profissional', title: 'Seu perfil profissional'},
  {key: 'verificacao', label: 'Verificação', title: 'Só falta confirmar quem é você'},
] as const;

type Campo = keyof RegisterFormProps;

// Quais campos o `trigger` do react-hook-form deve validar para liberar cada
// passo. Antes cada step reimplementava a checagem a mao, olhando so se a
// string tinha comprimento — o que aprovava e-mail invalido e CPF de 11 uns.
export const STEP_FIELDS: Record<number, Campo[]> = {
  1: ['name', 'email', 'phone', 'password'],
  2: ['atuation_type', 'category', 'subcategory'],
  3: ['cpf', 'zipcode', 'street', 'neighborhood', 'city', 'state'],
};

export const TOTAL_STEPS = STEPS.length;

export const normalizarStep = (valor: unknown): number => {
  const numero = Number.parseInt(`${valor}`, 10);

  if (!Number.isFinite(numero)) return 1;

  return Math.min(Math.max(numero, 1), TOTAL_STEPS);
};

export const stepDefinition = (valor: unknown): StepDefinition => STEPS[normalizarStep(valor) - 1];

export const camposDoStep = (valor: unknown): Campo[] => STEP_FIELDS[normalizarStep(valor)] ?? [];
